import { Component, OnInit, ChangeDetectorRef, Input } from "@angular/core";
import { PucaCitizenInformationService } from "./service/puca-citizen-information.service";
import { HecResponse } from "../../../../../../../../src/app/shared/shared-interfaces/hecResponse";
import { HEC_CONSTANTS } from "../../../../../../../../src/app/utilities/constants";
import { Router } from "@angular/router";
import { PucaCitizenInformationModel } from "./model/puca-citizen-information-model";
import { LoaderService } from '../../../../../../../../src/app/shared/sharedServices/loader.service';
import { decrypt } from '../../../../../../../../src/app/utilities/utilityFunctions';
import { PucaFormService } from '../puca-form.service';
import { PucaDataService } from '../../../services/puca-data.service';

@Component({
	selector: "kt-puca-citizen-information",
	templateUrl: "./puca-citizen-information.component.html",
	styleUrls: ["./puca-citizen-information.component.scss"],
})
export class PucaCitizenInformationComponent implements OnInit {
	public pucaCitizenInformation: PucaCitizenInformationModel = new PucaCitizenInformationModel();
	@Input("dropdownList") dropdownList: any = {};
	private applicationFormData: any = {};
	private loader: boolean = false;
	@Input() pucaApplication: any;
	@Input('formType') formType: string;
	@Input() isAdmin: boolean = false;
	public alertType: string;
	public alertMsgValue: string;
	public showErrorAlert: boolean;
	constructor(
		private pucaCitizenInformationService: PucaCitizenInformationService,
		private router: Router,
		private cdr: ChangeDetectorRef,
		private loaderService: LoaderService,
		private pucaFormService: PucaFormService,
		private pucaDataService: PucaDataService
	) {
		this.pucaFormService.setNewPucaApplication.subscribe(v => {
			this.pucaApplication = v;
			this.getAllServices();
			if (this.pucaApplication) {
				this.pucaCitizenInformation.HasUSVisa = this.pucaApplication.pucaApplicationDto.visaTypeId ? "1" : "2";
				this.pucaCitizenInformation.IsUSCitizen = this.pucaApplication.pucaApplicationDto.isUsResidency ? "1" : "2";

				if (this.pucaApplication.pucaApplicationDto.isUsCitizenship) this.pucaCitizenInformation.USCitizenshipStatus = HEC_CONSTANTS.US_CITIZENSHIP_STATUS.USCitizen;
				else this.pucaCitizenInformation.USCitizenshipStatus = HEC_CONSTANTS.US_CITIZENSHIP_STATUS.NonCitizen;
				if (this.pucaApplication.pucaApplicationDto.alienRegistrationNumber) this.pucaCitizenInformation.USCitizenshipStatus = HEC_CONSTANTS.US_CITIZENSHIP_STATUS.Permanent;
				if (this.pucaApplication.pucaApplicationDto.visaTypeId) this.pucaCitizenInformation.USCitizenshipStatus = HEC_CONSTANTS.US_CITIZENSHIP_STATUS.NonCitizen;

				this.pucaCitizenInformation.AlienRegNumber = this.pucaApplication.pucaApplicationDto.alienRegistrationNumber;
				this.pucaCitizenInformation.CountryOfCitizenship = this.pucaApplication.pucaApplicationDto.countryCitizenshipId;
				this.pucaCitizenInformation.OtherCountryOfCitizenship = this.pucaApplication.pucaApplicationDto.otherCountryId;
				this.pucaCitizenInformation.VisaType = this.pucaApplication.pucaApplicationDto.visaTypeId;
				this.pucaCitizenInformation.VisaCategory = this.pucaApplication.pucaApplicationDto.visaCategoryId;
			}
		})
	}

	ngOnInit() {

		this.dropdownList["CountryList"] = [];
		this.dropdownList["USCitizenshipList"] = [];
		this.dropdownList["VisaTypeList"] = [];
		this.dropdownList["USCitizenStatus"] = HEC_CONSTANTS.US_CITIZEN_SHIP_STATUS_LIST;

		this.getAllServices();

		if (this.pucaApplication) {
			this.pucaCitizenInformation.HasUSVisa = this.pucaApplication.pucaApplicationDto.visaTypeId ? "1" : "2";
			this.pucaCitizenInformation.IsUSCitizen = this.pucaApplication.pucaApplicationDto.isUsResidency ? "1" : "2";

			if (this.pucaApplication.pucaApplicationDto.isUsCitizenship) this.pucaCitizenInformation.USCitizenshipStatus = HEC_CONSTANTS.US_CITIZENSHIP_STATUS.USCitizen;
			else this.pucaCitizenInformation.USCitizenshipStatus = HEC_CONSTANTS.US_CITIZENSHIP_STATUS.NonCitizen;
			if (this.pucaApplication.pucaApplicationDto.alienRegistrationNumber) this.pucaCitizenInformation.USCitizenshipStatus = HEC_CONSTANTS.US_CITIZENSHIP_STATUS.Permanent;
			if (this.pucaApplication.pucaApplicationDto.visaTypeId) this.pucaCitizenInformation.USCitizenshipStatus = HEC_CONSTANTS.US_CITIZENSHIP_STATUS.NonCitizen;

			this.pucaCitizenInformation.AlienRegNumber = this.pucaApplication.pucaApplicationDto.alienRegistrationNumber;
			this.pucaCitizenInformation.CountryOfCitizenship = this.pucaApplication.pucaApplicationDto.countryCitizenshipId;
			this.pucaCitizenInformation.OtherCountryOfCitizenship = this.pucaApplication.pucaApplicationDto.otherCountryId;
			this.pucaCitizenInformation.VisaType = this.pucaApplication.pucaApplicationDto.visaTypeId;
			this.pucaCitizenInformation.VisaCategory = this.pucaApplication.pucaApplicationDto.visaCategoryId;

		}
	}

	public getSelectedCountryOfCitizenship(e, v) {
		this.setErrorAlert(false);
		this.pucaCitizenInformation.CountryOfCitizenship = e;
		this.cdr.detectChanges();
	}
	public getSelectedOtherCountryOfCitizenship(e, v) {
		this.setErrorAlert(false);
		this.pucaCitizenInformation.OtherCountryOfCitizenship = e;
	}

	public changeCurrentlyInUS(e) {
		this.setErrorAlert(false);
		this.pucaCitizenInformation.IsUSCitizen = e;
	}

	public getSelectedUSCitizenshipStatus(e) {
		this.setErrorAlert(false);
		this.pucaCitizenInformation.USCitizenshipStatus = e;
		this.pucaCitizenInformation.HasUSVisa = "0";
		this.pucaCitizenInformation.AlienRegNumber = '';
	}

	public getSelectedUSVisaType(e) {
		this.setErrorAlert(false);
		this.pucaCitizenInformation.VisaType = e;
		this.pucaCitizenInformation.VisaCategory = '';
	}

	public getSelectedUSVisaCategory(e) {
		this.setErrorAlert(false);
		this.pucaCitizenInformation.VisaCategory = e;
	}

	public getAlignNumber(e) {
		this.setErrorAlert(false);
		this.pucaCitizenInformation.AlienRegNumber = e;
	}

	private getAllServices(): void {
		this.setErrorAlert(false);
		this.loadApplicationFormData();
	}

	private async loadApplicationFormData() {
		this.setErrorAlert(false);
		await this.getApplicationFormData();
	}

	private getApplicationFormData() {
		this.setErrorAlert(false);
		return new Promise((resolve, reject) => {
			const profile = JSON.parse(
				decrypt(localStorage.getItem("esp-profile-details"))
			);
			this.pucaCitizenInformationService.getApplicationFormData(this.pucaApplication ? this.pucaApplication.pucaApplicationDto.id : 0, this.pucaApplication ? this.pucaApplication.pucaApplicationDto.commonProfileId : profile["profileId"]).subscribe(
				(res: HecResponse) => {
					if (res.code == 0 || res.statusCode == 200) {
						this.applicationFormData = (res.result) ? res.result : res.data;
						this.dropdownList["CountryList"] = this.applicationFormData.countryList;
						this.dropdownList["USCitizenshipList"] = this.applicationFormData.countryList;
						this.dropdownList["VisaTypeList"] = this.applicationFormData.visaList;
						this.dropdownList["VisaCategoryList"] = this.applicationFormData.visaCategoryList;
						resolve(this.applicationFormData);
						this.cdr.detectChanges();
					} else {
						reject(null);
					}
				},
				(err) => {
					reject(null);
				}
			);
		}).catch(function (error) {
		});
	}

	showVisaType = () => (this.pucaCitizenInformation.IsUSCitizen === "1" && this.pucaCitizenInformation.USCitizenshipStatus === HEC_CONSTANTS.US_CITIZENSHIP_STATUS.NonCitizen) || this.pucaCitizenInformation.HasUSVisa === "1"
	showAlienRegNumber = () => this.pucaCitizenInformation.USCitizenshipStatus === HEC_CONSTANTS.US_CITIZENSHIP_STATUS.Permanent
	showCitizenShipStatus = () => this.pucaCitizenInformation.IsUSCitizen === "1" || this.pucaCitizenInformation.IsUSCitizen === "2"
	showHasUSVisa = () => this.pucaCitizenInformation.IsUSCitizen === "2" && this.pucaCitizenInformation.USCitizenshipStatus === HEC_CONSTANTS.US_CITIZENSHIP_STATUS.NonCitizen

	setHasUSVisa = e => {
		this.setErrorAlert(false);
		this.pucaCitizenInformation.HasUSVisa = e;
	}

	showVisaCategory = () => this.showVisaType() && this.pucaCitizenInformation.VisaType == "30841";

	saveCitizenInfo = () => {
		this.setErrorAlert(false);

		if (this.formType == 'view') {
			this.pucaFormService.nextStep.next(true);
			return false;
		}

		if (this.formIsNotValid()) return false;

		return new Promise((resolve, reject) => {
			const profile = JSON.parse(
				decrypt(localStorage.getItem("esp-profile-details"))
			);
			this.loader = true;
			this.loaderService.setValue(this.loader);

			const payload: any = {
				data: {}
			};

			payload.data.configScholarshipId = this.pucaApplication ? this.pucaApplication.pucaApplicationDto.configScholarshipId : 0;
			payload.data.id = this.pucaApplication ? this.pucaApplication.pucaApplicationDto.id : 0;
			payload.data.commonProfileId = this.pucaApplication ? this.pucaApplication.pucaApplicationDto.commonProfileId : profile["profileId"];
			payload.data.isUsCitizenship = this.pucaCitizenInformation.USCitizenshipStatus === HEC_CONSTANTS.US_CITIZENSHIP_STATUS.USCitizen;
			payload.data.isUsResidency = this.pucaCitizenInformation.IsUSCitizen === "1";
			if (this.showAlienRegNumber()) {
				payload.data.alienRegistrationNumber = this.pucaCitizenInformation.AlienRegNumber;
				payload.data.visaTypeId = 0;
				payload.data.visaCategoryId = 0;
				payload.data.isUSVisa = true;
			}
			else {
				payload.data.alienRegistrationNumber = "";
				payload.data.isUSVisa = !!this.pucaCitizenInformation.VisaType;
				if (this.pucaCitizenInformation.HasUSVisa == "1" || ( payload.data.isUsResidency &&  this.pucaCitizenInformation.USCitizenshipStatus == HEC_CONSTANTS.US_CITIZENSHIP_STATUS.NonCitizen)) {
					payload.data.visaTypeId = this.pucaCitizenInformation.VisaType;

					if (payload.data.visaTypeId == "30841") payload.data.visaCategoryId = this.pucaCitizenInformation.VisaCategory;
					else payload.data.visaCategoryId = 0;
				}
				else {
					payload.data.visaTypeId = 0;
					payload.data.visaCategoryId = 0;
				}
			}

			payload.data.countryCitizenshipId = this.pucaCitizenInformation.CountryOfCitizenship;
			payload.data.otherCountryId = this.pucaCitizenInformation.OtherCountryOfCitizenship;

			this.pucaCitizenInformationService.saveApplication(payload).subscribe(
				(res: HecResponse) => {
					this.loader = false;
					this.loaderService.setValue(this.loader);

					if (res.code === 0) {
						resolve(res.result);
						this.pucaFormService.nextStep.next(true);
					}
				},
				(err) => {
					this.loader = false;
					this.loaderService.setValue(this.loader)
					this.cdr.detectChanges();
				}
			)
		});
	}


	public goBack() {
		this.setErrorAlert(false);
		this.pucaFormService.previousStep.next(true);
		this.cdr.detectChanges();
	}

	public cancelAttestaion() {
		if(this.pucaDataService.isAdmin){
			this.router.navigate(['/admin-dashboard/PAK-US-Admnin-Dashboard'])
		  }
		  else{
			this.router.navigate(['/'])
		  }
	  }


	formIsNotValid = () => {
		if ((this.showAlienRegNumber() && !this.pucaCitizenInformation.AlienRegNumber)
			|| (this.showVisaType() && !this.pucaCitizenInformation.VisaType)
			|| (this.showVisaCategory() && !this.pucaCitizenInformation.VisaCategory)
			|| (this.showHasUSVisa() && this.pucaCitizenInformation.HasUSVisa == '0')
			|| this.pucaCitizenInformation.IsUSCitizen == '0'
			|| !this.pucaCitizenInformation.CountryOfCitizenship
			|| this.pucaCitizenInformation.IsUSCitizen == '0'
			|| this.pucaCitizenInformation.USCitizenshipStatus == "0") {
			this.setErrorAlert(true);
			return true;
		}

		return false;
	}

	setErrorAlert = status => {
		this.showErrorAlert = status;

		if (status) {
			this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
			this.alertMsgValue = 'Please fill all the required fields.'
		}
		else {
			this.alertType = '';
			this.alertMsgValue = ''
		}
	}
}
